// Carries the originating Firestore code so the error boundary can show it in the issue label.
export class UserReadError extends Error {
  readonly code?: string;

  constructor(code?: string) {
    super(
      code
        ? `Reading the user document failed: ${code}`
        : 'Reading the user document failed',
    );
    this.name = 'UserReadError';
    this.code = code;
  }
}
